import React from 'react';
import ReactDOM from 'react-dom/client';

import Root from './components/Root';
import history from './history';
import store from './store';
import './i18n';
import { setupConsoleTracking } from './utils/hyperdx-tracking';

setupConsoleTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(Root, { store, history }));

if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
